import { render, staticRenderFns } from "./EditCategory.vue?vue&type=template&id=0bf9c4bc&scoped=true"
import script from "./EditCategory.vue?vue&type=script&lang=js"
export * from "./EditCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf9c4bc",
  null
  
)

export default component.exports